import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'

const PartialBodyBlock = ({ blockData: { body }, isPhone, t }) => {
  if (!body?.nonTTBHAllow) {
    return null
  }

  return (
    <div className="ttb-step__content-block">
      <span
        className={clsx(
          'ttb-step__content-body',
          !isPhone ? Typo.body1 : Typo.body2,
        )}
      >
        {body?.nonTTBHAllow &&
          hasLocizeTranslation(t, body.disabledKey, body.value)}
      </span>
    </div>
  )
}

PartialBodyBlock.propTypes = {
  blockData: PropTypes.shape({
    body: PropTypes.shape({
      nonTTBHAllow: PropTypes.bool,
      disabledKey: PropTypes.string,
      value: PropTypes.string,
    }),
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(PartialBodyBlock)

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(Extended)
